module.exports = __webpack_public_path__ + "img/az_outline.94ff3b09.png";